import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  mutableListOf6oorvk2mtdmp as mutableListOf,
  emptyList1g2z5xcrvp2zy as emptyList,
  get_lastIndex1yw0x4k50k51w as get_lastIndex,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  removeLastOrNull3odnlbetbttd4 as removeLastOrNull,
  addAll1k27qatfgp3k5 as addAll,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import {
  _ParseResult___get_value__impl__86mnxf3azxkbb11grfu as _ParseResult___get_value__impl__86mnxf,
  ParseError1ji8h7fh6q5w9 as ParseError,
} from './ParseResult.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  captureStack1fzi4aczwc4hg as captureStack,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  Exceptiondt2hlxn7j7vw as Exception,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  sortWith4fnm6b3vw03s as sortWith,
  listOfvhqybd2zx248 as listOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import {
  joinToString1cxrrlmo0chqs as joinToString,
  joinTo3lkanfaxbzac2 as joinTo,
  firstOrNull1982767dljvdy as firstOrNull,
  plus310ted5e4i90h as plus,
  toMutableList20rdgwi7d3cwi as toMutableList,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  asReversed308kw52j6ls1u as asReversed,
  asReversed2y2qzr7vrqd5 as asReversed_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ReversedViews.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  NumberSpanParserOperation3qyp02c4km7yu as NumberSpanParserOperation,
  UnconditionalModification151pp4lqfue9i as UnconditionalModification,
} from './ParserOperation.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function _Parser___init__impl__gdyfby(commands) {
  return commands;
}
function _get_commands__a20n1($this) {
  return $this;
}
function Parser__match_impl_nzt83d($this, input, initialContainer, startIndex) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var errors = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  // Inline function 'kotlinx.datetime.internal.format.parser.Parser.parse' call
  var parseOptions = mutableListOf([new (ParserState())(initialContainer, _get_commands__a20n1($this), startIndex)]);
  iterate_over_alternatives: while (true) {
    var tmp0_elvis_lhs = removeLastOrNull(parseOptions);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      break iterate_over_alternatives;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var state = tmp;
    var output = state.output_1.copy_1tks5_k$();
    var inputPosition = state.inputPosition_1;
    var parserStructure = state.parserStructure_1;
    // Inline function 'kotlin.run' call
    $l$block: {
      var inductionVariable = 0;
      var last = parserStructure.operations_1.get_size_woubt6_k$() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var ix = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlinx.datetime.internal.format.parser.ParseResult.match' call
          var this_0 = parserStructure.operations_1.get_c1px32_k$(ix).consume_ew3o91_k$(output, input, inputPosition);
          var tmp0_subject = _ParseResult___get_value__impl__86mnxf(this_0);
          if (typeof tmp0_subject === 'number') {
            inputPosition = _ParseResult___get_value__impl__86mnxf(this_0);
          } else {
            if (tmp0_subject instanceof ParseError()) {
              var it = _ParseResult___get_value__impl__86mnxf(this_0);
              errors.add_utx5q5_k$(it);
              break $l$block;
            } else {
              // Inline function 'kotlin.error' call
              var message = 'Unexpected parse result: ' + toString(_ParseResult___get_value__impl__86mnxf(this_0));
              throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
            }
          }
        }
         while (inductionVariable <= last);
      if (parserStructure.followedBy_1.isEmpty_y1axqb_k$()) {
        if (false || inputPosition === charSequenceLength(input)) {
          return output;
        } else {
          var tmp_0 = inputPosition;
          var it_0 = new (ParseError())(tmp_0, Parser$match$lambda);
          errors.add_utx5q5_k$(it_0);
        }
      } else {
        var inductionVariable_0 = parserStructure.followedBy_1.get_size_woubt6_k$() - 1 | 0;
        if (0 <= inductionVariable_0)
          do {
            var ix_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + -1 | 0;
            parseOptions.add_utx5q5_k$(new (ParserState())(output, parserStructure.followedBy_1.get_c1px32_k$(ix_0), inputPosition));
          }
           while (0 <= inductionVariable_0);
      }
    }
  }
  // Inline function 'kotlin.collections.sortByDescending' call
  if (errors.get_size_woubt6_k$() > 1) {
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp_1 = Parser$match$lambda_0;
    var tmp$ret$12 = new (sam$kotlin_Comparator$0())(tmp_1);
    sortWith(errors, tmp$ret$12);
  }
  throw ParseException().new_kotlinx_datetime_internal_format_parser_ParseException_8o9vn8_k$(errors);
}
function Parser__match$default_impl_x2xlti($this, input, initialContainer, startIndex, $super) {
  startIndex = startIndex === VOID ? 0 : startIndex;
  var tmp;
  if ($super === VOID) {
    tmp = Parser__match_impl_nzt83d($this, input, initialContainer, startIndex);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new (Parser())(tmp_0)).match_pog3ge_k$.call(new (Parser())($this), input, initialContainer, startIndex);
  }
  return tmp;
}
var ParserStateClass;
function ParserState() {
  if (ParserStateClass === VOID) {
    class $ {
      constructor(output, parserStructure, inputPosition) {
        this.output_1 = output;
        this.parserStructure_1 = parserStructure;
        this.inputPosition_1 = inputPosition;
      }
    }
    initMetadataForClass($, 'ParserState');
    ParserStateClass = $;
  }
  return ParserStateClass;
}
function Parser__toString_impl_x33iea($this) {
  return 'Parser(commands=' + $this.toString() + ')';
}
function Parser__hashCode_impl_bbxllf($this) {
  return hashCode($this);
}
function Parser__equals_impl_djxokv($this, other) {
  if (!(other instanceof Parser()))
    return false;
  var tmp0_other_with_cast = other instanceof Parser() ? other.commands_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.function_1 = function_0;
      }
      compare_bczr_k$(a, b) {
        return this.function_1(a, b);
      }
      compare(a, b) {
        return this.compare_bczr_k$(a, b);
      }
      getFunctionDelegate_jtodtf_k$() {
        return this.function_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.getFunctionDelegate_jtodtf_k$(), other.getFunctionDelegate_jtodtf_k$());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.getFunctionDelegate_jtodtf_k$());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function Parser$match$lambda() {
  return 'There is more input to consume';
}
function Parser$match$lambda_0(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = b.position_1;
  var tmp$ret$2 = a.position_1;
  return compareValues(tmp, tmp$ret$2);
}
var ParserClass;
function Parser() {
  if (ParserClass === VOID) {
    class $ {
      constructor(commands) {
        this.commands_1 = commands;
      }
      toString() {
        return Parser__toString_impl_x33iea(this.commands_1);
      }
      hashCode() {
        return Parser__hashCode_impl_bbxllf(this.commands_1);
      }
      equals(other) {
        return Parser__equals_impl_djxokv(this.commands_1, other);
      }
    }
    initMetadataForClass($, 'Parser');
    ParserClass = $;
  }
  return ParserClass;
}
var ParserStructureClass;
function ParserStructure() {
  if (ParserStructureClass === VOID) {
    class $ {
      constructor(operations, followedBy) {
        this.operations_1 = operations;
        this.followedBy_1 = followedBy;
      }
      toString() {
        return joinToString(this.operations_1, ', ') + '(' + joinToString(this.followedBy_1, ';') + ')';
      }
    }
    initMetadataForClass($, 'ParserStructure');
    ParserStructureClass = $;
  }
  return ParserStructureClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.serialVersionUID_1 = 5691186997393344103n;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var ParseExceptionClass;
function ParseException() {
  if (ParseExceptionClass === VOID) {
    class $ extends Exception() {
      constructor(errors) {
        return new.target.new_kotlinx_datetime_internal_format_parser_ParseException_8o9vn8_k$(errors);
      }
      static new_kotlinx_datetime_internal_format_parser_ParseException_8o9vn8_k$(errors) {
        var $this = this.new_kotlin_Exception_hsqbop_k$(formatError(errors));
        captureStack($this, $this.$throwableCtor_2);
        return $this;
      }
    }
    initMetadataForClass($, 'ParseException');
    ParseExceptionClass = $;
  }
  return ParseExceptionClass;
}
function concat(_this__u8e3s4) {
  var result = {_v: new (ParserStructure())(emptyList(), emptyList())};
  // Inline function 'kotlin.collections.mutableListOf' call
  var accumulatedOperations = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s = asReversed(_this__u8e3s4).iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var parser = _iterator__ex2g4s.next_20eer_k$();
    if (parser.followedBy_1.isEmpty_y1axqb_k$()) {
      accumulatedOperations.add_utx5q5_k$(parser.operations_1);
    } else {
      concat$flushAccumulatedOperations(accumulatedOperations, result);
      result._v = concat$simplifyAndAppend(parser, result._v);
    }
  }
  concat$flushAccumulatedOperations(accumulatedOperations, result);
  return result._v;
}
function formatError(errors) {
  if (errors.get_size_woubt6_k$() === 1) {
    return 'Position ' + errors.get_c1px32_k$(0).position_1 + ': ' + errors.get_c1px32_k$(0).message_1();
  }
  var averageMessageLength = 33;
  var tmp0_buffer = StringBuilder().new_kotlin_text_StringBuilder_wcb3z_k$(imul(averageMessageLength, errors.get_size_woubt6_k$()));
  return joinTo(errors, tmp0_buffer, ', ', 'Errors: ', VOID, VOID, VOID, formatError$lambda).toString();
}
function concat$mergeOperations(baseOperations, numberSpan, unconditionalModifications, simplifiedParserStructure) {
  var operationsToMerge = simplifiedParserStructure.operations_1;
  var firstOperation = firstOrNull(operationsToMerge);
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.collections.buildListInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  this_0.addAll_4lah1e_k$(baseOperations);
  if (numberSpan == null) {
    this_0.addAll_4lah1e_k$(operationsToMerge);
  } else {
    if (firstOperation instanceof NumberSpanParserOperation()) {
      this_0.add_utx5q5_k$(new (NumberSpanParserOperation())(plus(numberSpan, firstOperation.consumers_1)));
      var inductionVariable = 1;
      var last = get_lastIndex(operationsToMerge);
      if (inductionVariable <= last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this_0.add_utx5q5_k$(operationsToMerge.get_c1px32_k$(i));
        }
         while (!(i === last));
    } else {
      this_0.add_utx5q5_k$(new (NumberSpanParserOperation())(numberSpan));
      this_0.addAll_4lah1e_k$(operationsToMerge);
    }
  }
  this_0.addAll_4lah1e_k$(unconditionalModifications);
  var mergedOperations = this_0.build_nmwvly_k$();
  return new (ParserStructure())(mergedOperations, simplifiedParserStructure.followedBy_1);
}
function concat$simplifyAndAppend(_this__u8e3s4, other) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var newOperations = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var currentNumberSpan = null;
  // Inline function 'kotlin.collections.mutableListOf' call
  var unconditionalModifications = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s = _this__u8e3s4.operations_1.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var op = _iterator__ex2g4s.next_20eer_k$();
    if (op instanceof NumberSpanParserOperation()) {
      if (!(currentNumberSpan == null)) {
        currentNumberSpan.addAll_4lah1e_k$(op.consumers_1);
      } else {
        currentNumberSpan = toMutableList(op.consumers_1);
      }
    } else {
      if (op instanceof UnconditionalModification())
        unconditionalModifications.add_utx5q5_k$(op);
      else {
        if (!(currentNumberSpan == null)) {
          newOperations.add_utx5q5_k$(new (NumberSpanParserOperation())(currentNumberSpan));
          currentNumberSpan = null;
          newOperations.addAll_4lah1e_k$(unconditionalModifications);
          unconditionalModifications.clear_j9egeb_k$();
        }
        newOperations.add_utx5q5_k$(op);
      }
    }
  }
  // Inline function 'kotlin.collections.flatMap' call
  var tmp0 = _this__u8e3s4.followedBy_1;
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s_0 = tmp0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s_0.next_20eer_k$();
    var simplified = concat$simplifyAndAppend(element, other);
    var tmp;
    if (simplified.operations_1.isEmpty_y1axqb_k$()) {
      // Inline function 'kotlin.collections.ifEmpty' call
      var this_0 = simplified.followedBy_1;
      var tmp_0;
      if (this_0.isEmpty_y1axqb_k$()) {
        tmp_0 = listOf(simplified);
      } else {
        tmp_0 = this_0;
      }
      tmp = tmp_0;
    } else {
      tmp = listOf(simplified);
    }
    var list = tmp;
    addAll(destination, list);
  }
  // Inline function 'kotlin.collections.ifEmpty' call
  var tmp_1;
  if (destination.isEmpty_y1axqb_k$()) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!other.operations_1.isEmpty_y1axqb_k$()) {
      return concat$mergeOperations(newOperations, currentNumberSpan, unconditionalModifications, other);
    }
    tmp_1 = other.followedBy_1;
  } else {
    tmp_1 = destination;
  }
  var mergedTails = tmp_1;
  var tmp_2;
  var tmp_3;
  var tmp_4;
  if (currentNumberSpan == null) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    tmp_4 = !newOperations.isEmpty_y1axqb_k$();
  } else {
    tmp_4 = false;
  }
  if (tmp_4) {
    tmp_3 = true;
  } else {
    var tmp$ret$11;
    $l$block_0: {
      // Inline function 'kotlin.collections.none' call
      var tmp_5;
      if (isInterface(mergedTails, Collection())) {
        tmp_5 = mergedTails.isEmpty_y1axqb_k$();
      } else {
        tmp_5 = false;
      }
      if (tmp_5) {
        tmp$ret$11 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s_1 = mergedTails.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
        var element_0 = _iterator__ex2g4s_1.next_20eer_k$();
        var tmp_6 = firstOrNull(element_0.operations_1);
        if (tmp_6 instanceof NumberSpanParserOperation()) {
          tmp$ret$11 = false;
          break $l$block_0;
        }
      }
      tmp$ret$11 = true;
    }
    tmp_3 = tmp$ret$11;
  }
  if (tmp_3) {
    if (!(currentNumberSpan == null)) {
      newOperations.add_utx5q5_k$(new (NumberSpanParserOperation())(currentNumberSpan));
    }
    newOperations.addAll_4lah1e_k$(unconditionalModifications);
    tmp_2 = new (ParserStructure())(newOperations, mergedTails);
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(mergedTails, 10));
    var _iterator__ex2g4s_2 = mergedTails.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s_2.next_20eer_k$();
      var tmp$ret$15 = concat$mergeOperations(emptyList(), currentNumberSpan, unconditionalModifications, item);
      destination_0.add_utx5q5_k$(tmp$ret$15);
    }
    var newTails = destination_0;
    tmp_2 = new (ParserStructure())(newOperations, newTails);
  }
  return tmp_2;
}
function concat$flushAccumulatedOperations(accumulatedOperations, result) {
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!accumulatedOperations.isEmpty_y1axqb_k$()) {
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    var _iterator__ex2g4s = asReversed_0(accumulatedOperations).iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var parserOperations = _iterator__ex2g4s.next_20eer_k$();
      this_0.addAll_4lah1e_k$(parserOperations);
    }
    var operations = this_0.build_nmwvly_k$();
    result._v = concat$simplifyAndAppend(new (ParserStructure())(operations, emptyList()), result._v);
    accumulatedOperations.clear_j9egeb_k$();
  }
}
function formatError$lambda(it) {
  return 'position ' + it.position_1 + ": '" + it.message_1() + "'";
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Parser__match$default_impl_x2xlti as Parser__match$default_impl_x2xlti3tbegi3v1b9ik,
  _Parser___init__impl__gdyfby as _Parser___init__impl__gdyfby2rzvqqjkmwt8g,
  ParseException as ParseException603g9fc07eag,
  ParserStructure as ParserStructure2cqp7gjft5io4,
  concat as concat2z827ubu7ap26,
};
//endregion

//# sourceMappingURL=Parser.mjs.map
